import React from 'react';
import { Player as LPlayer } from '@lottiefiles/react-lottie-player';
import { useReducedMotion } from '@repo/ui/src/utils/useMediaQuery';

interface Props {
  isPlaying: boolean;
  loop?: boolean;
  autoplay?: boolean;
  animationData: any;
}

const Player = ({ animationData, isPlaying, loop = false, autoplay = false }: Props) => {
  const reduceMotion = useReducedMotion();
  const [lottie, setLottie] = React.useState<any>(null);

  React.useEffect(() => {
    if (reduceMotion && lottie) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      lottie.totalFrames;
      lottie.goToAndStop(lottie.totalFrames, true);
    }
  }, [reduceMotion, lottie]);

  return (
    <LPlayer
      lottieRef={(_lottie) => setLottie(_lottie)}
      autoplay={(autoplay || isPlaying) && !reduceMotion}
      loop={loop && !reduceMotion}
      src={animationData}
      keepLastFrame
      className="tw-h-full tw-w-full"
      rendererSettings={{
        preserveAspectRatio: 'xMidYMid meet',
      }}
    />
  );
};

export default React.memo(Player);
